import { render } from "./ServiciosSolicitadosListado.vue?vue&type=template&id=4a767b8e&ts=true"
import script from "./ServiciosSolicitadosListado.vue?vue&type=script&lang=ts"
export * from "./ServiciosSolicitadosListado.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__